export enum PaymentPlanTransactionType {
  CreditLine = 'creditLine',
  DisbursementWithdrawal = 'disbursementWithdrawal',
  DisbursementRefund = 'disbursementRefund',
}
